module.exports = __webpack_public_path__ + "static/media/9DESA8.7bfd5ecb.jpg";